export function renderAudio(element) {

    if (element.length === 0) {
        return;
    }

    if (typeof WaveSurfer === 'undefined') {
        console.error('WaveSurfer is not loaded. Ensure the script is included.');
        return;
    }

    const audioUrl = element.attr('data-url');

    if (!audioUrl) {
        console.error('No audio URL found for the element:', element);
        return;
    }

    const container = element.find('.audio-message-content')[0];
    if (!container) {
        // WaveSurfer requires a valid container to initialize.
        // If it's missing (e.g. audio is locked or gated with no waveform placeholder), we exit gracefully.
        return;
    }

    // Create the WaveSurfer instance
    const waveSurfer = WaveSurfer.create({
        container: container, // Pass the DOM element, not a jQuery object
        waveColor: growtypeChatAudioWaveColor,
        progressColor: growtypeChatAudioProgressColor,
        responsive: true,
        height: 30,
    });

    // Store instance for external control
    element[0].waveSurfer = waveSurfer;

    // Load the audio file
    waveSurfer.load(audioUrl);

    // Track ready state
    waveSurfer.on('ready', () => {
        element[0].audioIsReady = true;
        element.trigger('growtypeChatAudioReady');
    });

    waveSurfer.on('finish', () => {
        element.removeClass('is-playing');
    });

    // Attach playback controls (optional)
    element.find('[data-action="play"]').on('click', () => {
        if (waveSurfer.isPlaying()) {
            element.removeClass('is-playing');
            waveSurfer.pause();
        } else {
            element.addClass('is-playing');
            waveSurfer.play();
        }
    });

    // Attach playback controls (optional)
    element.find('[data-action="pause"]').on('click', () => {
        if (waveSurfer.isPlaying()) {
            element.removeClass('is-playing');
            waveSurfer.pause();
        } else {
            element.addClass('is-playing');
            waveSurfer.play();
        }
    });

    return waveSurfer;
}
